import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/api/pmiDictionary/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/pmiDictionary/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/pmiDictionary/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/api/pmiDictionary/delete',
    method: 'post',
    data
  })
}


export function PmiDictionaryGetByTypeId(params) {
  return request({
    url: '/api/PmiDictionary/GetByTypeId',
    method: 'get',
    params
  })
}


//发送审核印验
export function sendExamineApi(params) {
  return request({
      url: '/api/TrainPeople/PassSend',
      method: 'get',
      params
  })
}

//审核结果
export function examineScoreApi(data,params){
  return request({
      url: '/api/TrainPeople/PassScore',
      method: 'post',
      data,
      params
  })
}

// 获取列表
export function getByTypeId(params) {
    return request({
        url: '/api/PmiDictionary/GetByTypeId',
        method: 'get',
        params
    })
}